import Vue from 'vue';
import { ITeacherPortalState } from '../interfaces/teacher-portal-state.interface';
import { Meeting } from '../models/meeting.model';
import { User } from '@/core/models/user.model';


export const MEETING_MUTATIONS = {
  SET_MEETINGS: 'setMeetings',
  REMOVE_MEETING: 'removeMeeting',
  CREATE_MEETING: 'createMeeting',
  UPDATE_MEETING: 'updateMeeting',
  SET_MEMBERS_MEETING: 'setMembersMeeting',
  SET_USER_INFO: 'setUserInfo',
  SET_USERS_ORGANIZATION: 'setUsersOrganization'
};

export interface ISetMembersMutation {
  users: User[];
  meetingId: number;
}

class MeetingMutationsClass {

  setUserInfo(state: ITeacherPortalState, user: User) {
    state.user = user;
  }
  
  setMeetings(state: ITeacherPortalState, meetingList: any[]) {
    let meetings = meetingList.map(m => new Meeting(m));
    state.meetings = meetings;
  }

  removeMeeting(state: ITeacherPortalState, meeting: Meeting) {
    let i = state.meetings.findIndex(m => m.meetingId == meeting.meetingId);
    state.meetings.splice(i, 1);
  }

  createMeeting(state: ITeacherPortalState, meeting: Meeting) {
    state.meetings.push(meeting);
  }

  updateMeeting(state: ITeacherPortalState, meeting: Meeting) {
    let meetings = [...state.meetings];
    let i = meetings.findIndex(m => m.meetingId == meeting.meetingId);
    meetings[i] = meeting;
    Vue.set(state, 'meetings', meetings)
  }

  setMembersMeeting(state: ITeacherPortalState, { users, meetingId }: ISetMembersMutation) {
    let i = state.meetings.findIndex(m => m.meetingId == meetingId);
    state.meetings[i].members = users;
    Vue.set(state, 'meetings', state.meetings);
  }

  setUsersOrganization(state: ITeacherPortalState, data: any) {
    let usersOrganization: User[] = [];
    data.users.forEach((u: any) => {
      if(u.id !== state.user.id) {
        usersOrganization.push(new User(u));
      }
    });
    state.usersOrganization = data.add ? state.usersOrganization.concat(usersOrganization) : usersOrganization;
  }

}

export const MeetingMutations = new MeetingMutationsClass();